import _ from 'underscore';
import xtend from 'xtend';

import Store from '../lib/store/store-v2';

const KEY = 'userId';

export default function (apiBus, socketBus) {
    var state = Store();

    var apiActions = Store.ApiActions(state, KEY, {
        edit: function (event) {
            // non standard API response
            var newData = {};
            newData[event.data.users.userId] = event.data.users;
            this.state.set(xtend(this.state(), {
                data: xtend(this.state().data, newData),
                isResolving: false
            }));
        }
    });
    var socketActions = Store.WebsocketActions(state, KEY);

    Store.SubscribeToApi(apiActions, apiBus);
    var wsEvents = Store.WebsocketEvents.concat(['unlock']);
    Store.SubscribeToWebsocket(wsEvents, socketActions, socketBus);

    return {
        state: Store.Parse(state, function (data) {
            return (xtend(data, { data: _.toArray(data.data) }));
        })
    };
};
